:root {
  /* ==========================================================================
   Design System
   Color variables
   ========================================================================== */
  --beige: #bea96f;
  --beige-30: #f0e8d8;
  --beige-60: #d8c8a0;
  --green-dark: #1e9642;
  --green-mid-dark: #1fa040;
  --green: #20aa3f;
  --green-90: #48b753;
  --green-80: #66c368;
  --green-70: #93cf7c;
  --green-60: #addc91;
  --green-50: #bae0a2;
  --green-40: #c7e5b3;
  --green-30: #d4eac6;
  --green-20: #e2efd8;
  --green-10: #f0f8eb;
  --teal-dark: #005e5d;
  --teal-mid-dark: #126b69;
  --teal: #257675;
  --teal-90: #3e8685;
  --teal-80: #579695;
  --teal-70: #70a6a5;
  --teal-60: #89b6b5;
  --teal-50: #9ec4c3;
  --teal-40: #b4d2d1;
  --teal-30: #c4dddc;
  --teal-20: #d4e7e6;
  --teal-10: #f0f7f6;
  --pacific-dark: #0050b4;
  --pacific-mid-dark: #0061c1;
  --pacific: #0072ce;
  --pacific-90: #2284d5;
  --pacific-80: #4497dc;
  --pacific-70: #61a7e2;
  --pacific-60: #7eb7e8;
  --pacific-50: #96c4ed;
  --pacific-40: #afd2f2;
  --pacific-30: #c3ddf6;
  --pacific-20: #d6e8fa;
  --pacific-10: #eff8fd;
  --navy-dark: #002d72;
  --navy-mid-dark: #123c7c;
  --navy: #254b87;
  --navy-90: #3e5f95;
  --navy-80: #5674a3;
  --navy-70: #6f88b2;
  --navy-60: #889cc0;
  --navy-50: #9daecc;
  --navy-40: #b3c0d9;
  --navy-30: #c3cde2;
  --navy-20: #d3daeb;
  --navy-10: #f4f6fa;
  --purple-dark: #a01b68;
  --purple-mid-dark: #aa2071;
  --purple: #b4267a;
  --purple-90: #be438b;
  --purple-80: #c55998;
  --purple-70: #cd70a5;
  --purple-60: #d486b2;
  --purple-50: #dc9cbf;
  --purple-40: #e3b2cc;
  --purple-30: #ebc9d9;
  --purple-20: #f0d8e2;
  --purple-10: #fdf3f8;
  --red-dark: #b63014;
  --red-mid-dark: #c3381c;
  --red: #d14124;
  --red-90: #d75a40;
  --red-80: #dd735d;
  --red-70: #e28875;
  --red-60: #e79e8e;
  --red-50: #ebb0a3;
  --red-40: #f0c3b8;
  --red-30: #f3d1c8;
  --red-20: #f7e0d9;
  --red-10: #fbefec;
  --gold-dark: #dc731c;
  --gold-mid-dark: #ed881b;
  --gold: #ff9e1b;
  --gold-90: #ffab39;
  --gold-80: #ffb858;
  --gold-70: #ffc372;
  --gold-60: #ffce8d;
  --gold-50: #ffd8a3;
  --gold-40: #ffe1b9;
  --gold-30: #ffe8cb;
  --gold-20: #fff0dd;
  --gold-10: #fff6ec;
  --neutral-dark: #745745;
  --neutral-mid-dark: #7d604b;
  --neutral: #8a6c57;
  --neutral-90: #957865;
  --neutral-80: #a18573;
  --neutral-70: #ad9484;
  --neutral-60: #baa496;
  --neutral-50: #c6b4a9;
  --neutral-40: #d3c5bc;
  --neutral-30: #ddd1c9;
  --neutral-20: #e7ddd7;
  --neutral-10: #f8f5f2;
  --gray-darker: #293037;
  --gray-dark: #43484e;
  --gray-mid-dark: #4f5257;
  --gray: #5a5d61;
  --gray-90: #676a6f;
  --gray-80: #75787b;
  --gray-70: #838588;
  --gray-60: #919395;
  --gray-50: #a2a3a4;
  --gray-40: #b4b5b6;
  --gray-30: #c3c4c4;
  --gray-20: #d2d3d5;
  --gray-15: #dcdddf;
  --gray-10: #e7e8e9;
  --gray-5: #f7f8f9;
  --black: #101820;
  --white: #fff;
}

/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
:root {
  --font-stack: system-ui, sans-serif;
}

/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
body {
  color: var(--black);
  font-family: var(--font-stack);
  font-size: 100%;
  line-height: 1.375;
  -webkit-font-smoothing: antialiased;
}

button,
input,
select,
textarea {
  font-family: var(--font-stack);
}

strong,
b {
  font-weight: 600;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
}

h1,
.h1 {
  /* stylelint-enable */
  margin-bottom: 0.4411764706em;
  font-size: 2.125em;
  font-weight: 600;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
}
p + h1, ul + h1, ol + h1, dl + h1, figure + h1, img + h1, table + h1, blockquote + h1,
p + .h1,
ul + .h1,
ol + .h1,
dl + .h1,
figure + .h1,
img + .h1,
table + .h1,
blockquote + .h1 {
  margin-top: 1.7647058824em;
}
@media only all and (max-width: 37.5em) {
  h1,
  .h1 {
    /* stylelint-enable */
    margin-bottom: 0.5769230769em;
    font-size: 1.625em;
    font-weight: 600;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
  }
  p + h1, ul + h1, ol + h1, dl + h1, figure + h1, img + h1, table + h1, blockquote + h1,
  p + .h1,
  ul + .h1,
  ol + .h1,
  dl + .h1,
  figure + .h1,
  img + .h1,
  table + .h1,
  blockquote + .h1 {
    margin-top: 1.7307692308em;
  }
  h2 + h1, .h2 + h1, h3 + h1, .h3 + h1, h4 + h1, .h4 + h1, h5 + h1, .h5 + h1, h6 + h1, .h6 + h1,
  h2 + .h1,
  .h2 + .h1,
  h3 + .h1,
  .h3 + .h1,
  h4 + .h1,
  .h4 + .h1,
  h5 + .h1,
  .h5 + .h1,
  h6 + .h1,
  .h6 + .h1 {
    margin-top: 1.1538461538em;
  }
}

h2,
.h2 {
  /* stylelint-enable */
  margin-bottom: 0.5769230769em;
  font-size: 1.625em;
  font-weight: 600;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
}
p + h2, ul + h2, ol + h2, dl + h2, figure + h2, img + h2, table + h2, blockquote + h2,
p + .h2,
ul + .h2,
ol + .h2,
dl + .h2,
figure + .h2,
img + .h2,
table + .h2,
blockquote + .h2 {
  margin-top: 1.7307692308em;
}
h1 + h2, .h1 + h2, h3 + h2, .h3 + h2, h4 + h2, .h4 + h2, h5 + h2, .h5 + h2, h6 + h2, .h6 + h2,
h1 + .h2,
.h1 + .h2,
h3 + .h2,
.h3 + .h2,
h4 + .h2,
.h4 + .h2,
h5 + .h2,
.h5 + .h2,
h6 + .h2,
.h6 + .h2 {
  margin-top: 1.1538461538em;
}
@media only all and (max-width: 37.5em) {
  h2,
  .h2 {
    /* stylelint-enable */
    margin-bottom: 0.6818181818em;
    font-size: 1.375em;
    font-weight: normal;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
  }
  p + h2, ul + h2, ol + h2, dl + h2, figure + h2, img + h2, table + h2, blockquote + h2,
  p + .h2,
  ul + .h2,
  ol + .h2,
  dl + .h2,
  figure + .h2,
  img + .h2,
  table + .h2,
  blockquote + .h2 {
    margin-top: 1.3636363636em;
  }
}

h3,
.h3 {
  /* stylelint-enable */
  margin-bottom: 0.6818181818em;
  font-size: 1.375em;
  font-weight: normal;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
}
p + h3, ul + h3, ol + h3, dl + h3, figure + h3, img + h3, table + h3, blockquote + h3, h1 + h3, .h1 + h3, h2 + h3, .h2 + h3, h4 + h3, .h4 + h3, h5 + h3, .h5 + h3, h6 + h3, .h6 + h3,
p + .h3,
ul + .h3,
ol + .h3,
dl + .h3,
figure + .h3,
img + .h3,
table + .h3,
blockquote + .h3,
h1 + .h3,
.h1 + .h3,
h2 + .h3,
.h2 + .h3,
h4 + .h3,
.h4 + .h3,
h5 + .h3,
.h5 + .h3,
h6 + .h3,
.h6 + .h3 {
  margin-top: 1.3636363636em;
}
@media only all and (max-width: 37.5em) {
  h3,
  .h3 {
    /* stylelint-enable */
    margin-bottom: 0.8333333333em;
    font-size: 1.125em;
    font-weight: 500;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
  }
}

h4,
.h4 {
  /* stylelint-enable */
  margin-bottom: 0.8333333333em;
  font-size: 1.125em;
  font-weight: 500;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
}
p + h4, ul + h4, ol + h4, dl + h4, figure + h4, img + h4, table + h4, blockquote + h4, h1 + h4, .h1 + h4, h2 + h4, .h2 + h4, h3 + h4, .h3 + h4, h5 + h4, .h5 + h4, h6 + h4, .h6 + h4,
p + .h4,
ul + .h4,
ol + .h4,
dl + .h4,
figure + .h4,
img + .h4,
table + .h4,
blockquote + .h4,
h1 + .h4,
.h1 + .h4,
h2 + .h4,
.h2 + .h4,
h3 + .h4,
.h3 + .h4,
h5 + .h4,
.h5 + .h4,
h6 + .h4,
.h6 + .h4 {
  margin-top: 1.6666666667em;
}
@media only all and (max-width: 37.5em) {
  h4,
  .h4 {
    margin-bottom: 0.625em;
    font-size: 1em;
    line-height: 1.125;
  }
}

h5,
.h5 {
  /* stylelint-enable */
  margin-bottom: 1.0714285714em;
  font-size: 0.875em;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 1.25;
  text-transform: uppercase;
}
p + h5, ul + h5, ol + h5, dl + h5, figure + h5, img + h5, table + h5, blockquote + h5, h1 + h5, .h1 + h5, h2 + h5, .h2 + h5, h3 + h5, .h3 + h5, h4 + h5, .h4 + h5, h6 + h5, .h6 + h5,
p + .h5,
ul + .h5,
ol + .h5,
dl + .h5,
figure + .h5,
img + .h5,
table + .h5,
blockquote + .h5,
h1 + .h5,
.h1 + .h5,
h2 + .h5,
.h2 + .h5,
h3 + .h5,
.h3 + .h5,
h4 + .h5,
.h4 + .h5,
h6 + .h5,
.h6 + .h5 {
  margin-top: 2.1428571429em;
}

h6,
.h6 {
  /* stylelint-enable */
  margin-bottom: 1.25em;
  font-size: 0.75em;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 1.25;
  text-transform: uppercase;
}
p + h6, ul + h6, ol + h6, dl + h6, figure + h6, img + h6, table + h6, blockquote + h6, h1 + h6, .h1 + h6, h2 + h6, .h2 + h6, h3 + h6, .h3 + h6, h4 + h6, .h4 + h6, h5 + h6, .h5 + h6,
p + .h6,
ul + .h6,
ol + .h6,
dl + .h6,
figure + .h6,
img + .h6,
table + .h6,
blockquote + .h6,
h1 + .h6,
.h1 + .h6,
h2 + .h6,
.h2 + .h6,
h3 + .h6,
.h3 + .h6,
h4 + .h6,
.h4 + .h6,
h5 + .h6,
.h5 + .h6 {
  margin-top: 2.5em;
}

.lead-paragraph {
  /* stylelint-enable */
  margin-bottom: 0.6818181818em;
  font-size: 1.375em;
  font-weight: normal;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
  margin-top: 0;
  margin-bottom: 15px;
}
@media only all and (max-width: 37.5em) {
  .lead-paragraph {
    font-size: 1.125em;
  }
}

.superheading {
  margin-bottom: 0.4166666667em;
  font-size: 3em;
  font-weight: normal;
  line-height: 1.25;
}

p,
ul,
ol,
dl,
figure,
table,
blockquote {
  margin-top: 0;
  margin-bottom: 0.9375em;
}
p:last-child,
ul:last-child,
ol:last-child,
dl:last-child,
figure:last-child,
table:last-child,
blockquote:last-child {
  margin-bottom: 0;
}

p + ul,
p + ol {
  margin-top: -0.3125em;
}

ul ul,
ol ol,
ul ol,
ol ul {
  margin-top: 0.5em;
}

li {
  margin-bottom: 0.5em;
}
li:last-child, nav li {
  margin-bottom: 0;
}

a {
  border-width: 0;
  border-style: dotted;
  border-color: var(--pacific);
  color: var(--pacific);
  text-decoration: none;
}
a:visited, a.visited {
  border-color: var(--teal);
  color: var(--teal);
}
a:hover, a.hover {
  border-style: solid;
  border-color: var(--pacific-dark);
  color: var(--pacific-dark);
}
a:focus, a.focus {
  border-style: solid;
  outline: thin dotted;
}
a:active, a.active {
  border-style: solid;
  border-color: var(--navy);
  color: var(--navy);
}

p a,
li a,
dd a {
  border-bottom-width: 1px;
}

nav a {
  border-bottom-width: 0;
}

ul {
  padding-left: 1.125em;
  list-style: square;
}

ul ul {
  list-style-type: circle;
}

ol {
  padding-left: 1.3125em;
}
ol li:nth-last-child(n+10),
ol li:nth-last-child(n+10) ~ li {
  margin-left: 0.5625rem;
}

ol ol {
  list-style-type: lower-alpha;
}
ol ol li {
  margin-left: 0 !important;
}

ol ol ol {
  list-style-type: lower-roman;
}

nav ul,
nav ol,
nav ul ul,
nav ol ol {
  list-style: none;
  list-style-image: none;
}

caption {
  margin-bottom: 0.625em;
  text-align: left;
}

th,
td {
  padding: 0.625em;
}
thead th,
thead td {
  padding: 0.7142857143em;
  background: var(--gray-5);
  color: var(--black);
  font-size: 1em;
  vertical-align: top;
}

thead,
tbody tr {
  border-bottom: 1px solid var(--gray);
}

th {
  font-weight: 600;
  text-align: left;
}
thead th h2,
thead th .h2,
thead th h3,
thead th .h3,
thead th h4,
thead th .h4,
thead th h5,
thead th .h5,
thead th h6,
thead th .h6 {
  /* stylelint-enable */
  margin-bottom: 1.0714285714em;
  font-size: 0.875em;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 1.25;
  text-transform: uppercase;
  /* stylelint-disable no-duplicate-selectors */
  /* stylelint-enable */
}
p + thead th h2, ul + thead th h2, ol + thead th h2, dl + thead th h2, figure + thead th h2, img + thead th h2, table + thead th h2, blockquote + thead th h2, h1 + thead th h2, .h1 + thead th h2, h2 + thead th h2, .h2 + thead th h2, h3 + thead th h2, .h3 + thead th h2, h4 + thead th h2, .h4 + thead th h2, h6 + thead th h2, .h6 + thead th h2,
p + thead th .h2,
ul + thead th .h2,
ol + thead th .h2,
dl + thead th .h2,
figure + thead th .h2,
img + thead th .h2,
table + thead th .h2,
blockquote + thead th .h2,
h1 + thead th .h2,
.h1 + thead th .h2,
h2 + thead th .h2,
.h2 + thead th .h2,
h3 + thead th .h2,
.h3 + thead th .h2,
h4 + thead th .h2,
.h4 + thead th .h2,
h6 + thead th .h2,
.h6 + thead th .h2,
p + thead th h3,
ul + thead th h3,
ol + thead th h3,
dl + thead th h3,
figure + thead th h3,
img + thead th h3,
table + thead th h3,
blockquote + thead th h3,
h1 + thead th h3,
.h1 + thead th h3,
h2 + thead th h3,
.h2 + thead th h3,
h3 + thead th h3,
.h3 + thead th h3,
h4 + thead th h3,
.h4 + thead th h3,
h6 + thead th h3,
.h6 + thead th h3,
p + thead th .h3,
ul + thead th .h3,
ol + thead th .h3,
dl + thead th .h3,
figure + thead th .h3,
img + thead th .h3,
table + thead th .h3,
blockquote + thead th .h3,
h1 + thead th .h3,
.h1 + thead th .h3,
h2 + thead th .h3,
.h2 + thead th .h3,
h3 + thead th .h3,
.h3 + thead th .h3,
h4 + thead th .h3,
.h4 + thead th .h3,
h6 + thead th .h3,
.h6 + thead th .h3,
p + thead th h4,
ul + thead th h4,
ol + thead th h4,
dl + thead th h4,
figure + thead th h4,
img + thead th h4,
table + thead th h4,
blockquote + thead th h4,
h1 + thead th h4,
.h1 + thead th h4,
h2 + thead th h4,
.h2 + thead th h4,
h3 + thead th h4,
.h3 + thead th h4,
h4 + thead th h4,
.h4 + thead th h4,
h6 + thead th h4,
.h6 + thead th h4,
p + thead th .h4,
ul + thead th .h4,
ol + thead th .h4,
dl + thead th .h4,
figure + thead th .h4,
img + thead th .h4,
table + thead th .h4,
blockquote + thead th .h4,
h1 + thead th .h4,
.h1 + thead th .h4,
h2 + thead th .h4,
.h2 + thead th .h4,
h3 + thead th .h4,
.h3 + thead th .h4,
h4 + thead th .h4,
.h4 + thead th .h4,
h6 + thead th .h4,
.h6 + thead th .h4,
p + thead th h5,
ul + thead th h5,
ol + thead th h5,
dl + thead th h5,
figure + thead th h5,
img + thead th h5,
table + thead th h5,
blockquote + thead th h5,
h1 + thead th h5,
.h1 + thead th h5,
h2 + thead th h5,
.h2 + thead th h5,
h3 + thead th h5,
.h3 + thead th h5,
h4 + thead th h5,
.h4 + thead th h5,
h6 + thead th h5,
.h6 + thead th h5,
p + thead th .h5,
ul + thead th .h5,
ol + thead th .h5,
dl + thead th .h5,
figure + thead th .h5,
img + thead th .h5,
table + thead th .h5,
blockquote + thead th .h5,
h1 + thead th .h5,
.h1 + thead th .h5,
h2 + thead th .h5,
.h2 + thead th .h5,
h3 + thead th .h5,
.h3 + thead th .h5,
h4 + thead th .h5,
.h4 + thead th .h5,
h6 + thead th .h5,
.h6 + thead th .h5,
p + thead th h6,
ul + thead th h6,
ol + thead th h6,
dl + thead th h6,
figure + thead th h6,
img + thead th h6,
table + thead th h6,
blockquote + thead th h6,
h1 + thead th h6,
.h1 + thead th h6,
h2 + thead th h6,
.h2 + thead th h6,
h3 + thead th h6,
.h3 + thead th h6,
h4 + thead th h6,
.h4 + thead th h6,
h6 + thead th h6,
.h6 + thead th h6,
p + thead th .h6,
ul + thead th .h6,
ol + thead th .h6,
dl + thead th .h6,
figure + thead th .h6,
img + thead th .h6,
table + thead th .h6,
blockquote + thead th .h6,
h1 + thead th .h6,
.h1 + thead th .h6,
h2 + thead th .h6,
.h2 + thead th .h6,
h3 + thead th .h6,
.h3 + thead th .h6,
h4 + thead th .h6,
.h4 + thead th .h6,
h6 + thead th .h6,
.h6 + thead th .h6 {
  margin-top: 2.1428571429em;
}
thead th h2,
thead th .h2,
thead th h3,
thead th .h3,
thead th h4,
thead th .h4,
thead th h5,
thead th .h5,
thead th h6,
thead th .h6 {
  margin: 0;
  font-size: inherit;
}

blockquote {
  margin-right: 0.9375em;
  margin-left: 0.9375em;
}
@media only all and (min-width: 37.5625em) {
  blockquote {
    margin-right: 1.875em;
    margin-left: 1.875em;
  }
}

img {
  max-width: 100%;
}

figure {
  margin-right: 0;
  margin-left: 0;
}
figure img {
  vertical-align: middle;
}

pre,
code {
  background: var(--gray-5);
  border-radius: 4px;
  color: var(--black);
  font-family: "Input Mono", Consolas, Monaco, "Courier New", monospace;
}

code {
  padding: 0.2307692308em 0.2307692308em 0;
  font-size: 0.8125em;
}

pre {
  display: block;
  padding: 0.625em 0.9375em;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
pre code {
  padding: 0;
  background-color: transparent;
}